import { CircularProgress, IconButton } from '@material-ui/core';
import _ from 'lodash';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import momentTz from 'moment-timezone';
import moment from 'moment';
import { connect } from 'react-redux';
import { initialize, submit } from 'redux-form';
import { GREEN, MATCH_TAG_MODE, RED, SUBSCRIPTION_TYPES } from '../../../_config/consts';
import {
  formatSecondsFromStartOfDayToTimeDisplay,
  formatTimePickerValueToSecondsFromStartOfDay,
} from '../../../_config/formatter.js';
import { localizeHelpCenterLink } from '../../../_config/utils.js';
import * as CredentialActions from '../../../redux/actions/credential.actions';
import * as ModalActions from '../../../redux/actions/modal.actions';
import * as TagActions from '../../../redux/actions/tag.actions';
import * as UserActions from '../../../redux/actions/user.actions';
import * as UtilsActions from '../../../redux/actions/utils.actions';
import ArrowLeftIconCustom from '../../CustomIcons/ArrowLeftIconCustom.jsx';
import CheckOutlineIconCustom from '../../CustomIcons/CheckOutlineIconCustom.jsx';
import MDButton from '../../MDButton/MDButton.jsx';
import FormFlatContainer from '../../forms/Elements/FormFlatContainer.jsx';
import OpertoActivationForm from '../../forms/Integrations/OpertoActivationForm.jsx';
import OpertoSelectPropertiesForm from '../../forms/Integrations/OpertoSelectPropertiesForm.jsx';


@connect(state => ({
  language: state.settings.language,
  lockTags: state.tags.lock.data,
  locksFilteredByTags: _.get(state, 'credentials.selectedCredential.locksFilteredByTags'),
  form: state.form.OpertoSelectPropertiesForm,
}))
class OpertoSettingsOperationalSection extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isActive: null,
      integrationData: null,
      opertoProperties: [],
      opertoData: {
        clientId: null,
        clientSecret: null,
        properties: null,
      },
    };
  }

  loadOpertoIntegrationData() {
    const { dispatch } = this.props;
    const integration = dispatch(UserActions.getIntegrationAdditionalInfo(SUBSCRIPTION_TYPES.OPERTO_INTEGRATION));
    if (integration && integration.data) {
      return integration.data;
    }
    return null;
  }

  async fetchOpertoPropertiesForActiveIntegration(integrationData) {
    const { dispatch } = this.props;
    if (!integrationData || !integrationData.clientId || !integrationData.clientSecret) {
      this.setState({ opertoProperties: [] });
      return;
    }
    try {
      const properties = await dispatch(UserActions.loginWithOpertoAndGetProperties({
        clientId: integrationData.clientId,
        clientSecret: integrationData.clientSecret,
      }));
      this.setState({ opertoProperties: properties || [] });
    } catch (error) {
      this.setState({ opertoProperties: [] });
    }
  }

  formatPropertiesList(propertyIds, opertoProperties) {
    if (propertyIds && propertyIds.length) {
      return _.map(propertyIds, id => {
        const property = _.find(opertoProperties, p => p.id === id);
        if (property) {
          return property.name;
        }
        return id;
      }).join(', ');
    }
    return '-';
  }

  formatLockTagIds(tagIds, lockTags) {
    if (tagIds && tagIds.length) {
      return _.map(tagIds, id => {
        const tag = _.find(lockTags, t => t.id === id);
        if (tag) {
          return tag.name;
        }
        return id;
      }).join(', ');
    }
    return '-';
  }

  async componentDidMount() {
    const { dispatch } = this.props;
    const isActive = dispatch(UserActions.userHasIntegrationActive(SUBSCRIPTION_TYPES.OPERTO_INTEGRATION));
    const integrationData = isActive ? this.loadOpertoIntegrationData() : null;
    if (isActive) {
      const includeSpecialTags = true;
      dispatch(TagActions.fetchLockTags(includeSpecialTags, 0, 200));
      if (integrationData) {
        await this.fetchOpertoPropertiesForActiveIntegration(integrationData);
      }
    }
    this.setState({ isActive, integrationData });
  }

  componentDidUpdate(prevProps, prevState) {
    const { opertoData: { properties: prevProperties } } = prevState;
    const { opertoData: { properties } } = this.state;
    if (properties && !prevProperties) {
      const { dispatch } = this.props;
      const includeSpecialTags = true;
      dispatch(TagActions.fetchLockTags(includeSpecialTags, 0, 20));
    }
  }

  async onOpertoLoginAndGetProperties(loginData) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const properties = await dispatch(UserActions.loginWithOpertoAndGetProperties({
        clientId: loginData.clientId,
        clientSecret: loginData.clientSecret,
      }));
      if (properties) {
        const opertoData = {
          clientId: loginData.clientId,
          clientSecret: loginData.clientSecret,
          properties,
        };
        this.setState({ opertoData });
      }
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(initialize('OpertoSelectPropertiesForm', {
        lockTagMatchingMode: MATCH_TAG_MODE.AT_LEAST_ONE_TAG,
        timezone: momentTz.tz.guess(),
        useReservationCheckInCheckOutTime: false,
        checkInTimeOverride: moment().startOf('day').add(9, 'hours').valueOf(),
        checkOutTimeOverride: moment().startOf('day').add(17, 'hours').valueOf(),
        coldStart: true,
      }));
    } catch (error) {
      let errorMessage = 'integrationConnectionError';
      if (error && error.message === 'OPERTO_ACTIVATION_FAILED_NO_PROPERTIES') {
        errorMessage = 'opertoNoPropertiesFound';
      }
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity={errorMessage} /></h6>),
        },
      }));
    }
  }

  async onActivateOpertoIntegration(formData) {
    const { dispatch } = this.props;
    const { opertoData: { clientId, clientSecret } } = this.state;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const propertiesSelected = _.map(formData.properties, property => (property && property.value !== undefined ? property.value : property));
      const commonLockTagIds = formData.lockTags
        ? _.map(formData.lockTags.filter(tag => tag.type !== 'private_unit'), tag => tag.id)
        : [];
      const activationDTO = {
        clientId,
        clientSecret,
        properties: propertiesSelected,
        commonLockTagIds,
        lockTagMatchingMode: formData.lockTagMatchingMode,
        timeZone: formData.timezone || momentTz.tz.guess(),
        checkInTimeOverride: formData.useReservationCheckInCheckOutTime
          ? undefined
          : formatTimePickerValueToSecondsFromStartOfDay(formData.checkInTimeOverride),
        checkOutTimeOverride: formData.useReservationCheckInCheckOutTime
          ? undefined
          : formatTimePickerValueToSecondsFromStartOfDay(formData.checkOutTimeOverride),
        coldStart: formData.coldStart,
      };
      await dispatch(UserActions.activateOpertoIntegration(activationDTO));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      await dispatch(UserActions.fetchCurrentActiveIntegrations());
      const integrationData = this.loadOpertoIntegrationData();
      const includeSpecialTags = true;
      dispatch(TagActions.fetchLockTags(includeSpecialTags, 0, 200));
      this.setState({ isActive: true, integrationData });
      if (integrationData) {
        await this.fetchOpertoPropertiesForActiveIntegration(integrationData);
      }
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="integrationConnectionSuccess" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity="integrationConnectionError" /></h6>),
        },
      }));
    }
  }

  onDeactivateIntegrationRequest() {
    const { dispatch } = this.props;
    const params = {
      modalType: 'CONFIRM_TO_CONTINUE_MODAL',
      modalProps: {
        title: 'confirmBeforeContinue',
        body: <Entity entity="disableIntegrationConfirm" />,
        onConfirmText: <Entity entity="yes" />,
        onConfirm: () => this.onDeactivateIntegration(),
        onCancelText: <Entity entity="no" />,
        onCancel: () => dispatch(ModalActions.hideModal()),
      },
    };
    dispatch(ModalActions.showModal(params));
  }

  async onDeactivateIntegration() {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const opertoIntegrationDTO = dispatch(UserActions.getActiveIntegration(SUBSCRIPTION_TYPES.OPERTO_INTEGRATION));
      if (opertoIntegrationDTO && opertoIntegrationDTO.id) {
        await dispatch(UserActions.disableIntegration(opertoIntegrationDTO.id));
        dispatch(UtilsActions.setSpinnerVisibile(false));
        dispatch(UserActions.fetchCurrentActiveIntegrations());
        this.setState({ isActive: false, integrationData: null, opertoProperties: [] });
        dispatch(ModalActions.showModal({
          modalType: 'SUCCESS_ALERT',
          modalProps: {
            message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedSuccess" /></h6>),
          },
        }));
      } else {
        dispatch(UtilsActions.setSpinnerVisibile(false));
        dispatch(ModalActions.showModal({
          modalType: 'ERROR_ALERT',
          modalProps: {
            anchorOrigin: { vertical: 'top', horizontal: 'center' },
            message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedError" /></h6>),
          },
        }));
      }
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedError" /></h6>),
        },
      }));
    }
  }

  onOpenActivationInfo() {
    const helpURL = localizeHelpCenterLink('luckey-operto-integration-activation-steps');
    window.open(helpURL);
  }

  onGoBackToLogin() {
    const opertoData = {
      clientId: null,
      clientSecret: null,
      properties: null,
    };
    this.setState({ opertoData });
  }

  filterLockTags(value) {
    const { dispatch } = this.props;
    const includeSpecialTags = true;
    dispatch(TagActions.cancelFetchLockTagsByFilter());
    dispatch(TagActions.fetchLockTagsByFilter(value, 200, includeSpecialTags));
  }

  fetchLocksByTags(page, append) {
    const { dispatch } = this.props;
    dispatch((dispatchInner, getState) => {
      const form = getState().form.OpertoSelectPropertiesForm;
      dispatchInner(CredentialActions.fetchLocksByTagsForm(form, 0, page, append));
    });
  }

  render() {
    const { isActive, integrationData, opertoProperties, opertoData: { properties } } = this.state;
    const { dispatch, lockTags, locksFilteredByTags } = this.props;

    return (
      <div style={{ paddingLeft: 20, paddingRight: 25, paddingTop: 10, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <img alt="operto" src="/imgs/common/integrationLogos/operto.png" style={{ height: 70, alignSelf: 'center' }} />
        {isActive === null ? (
          <div style={{ marginTop: 40, display: 'flex', justifyContent: 'center' }}>
            <CircularProgress />
          </div>
        ) : isActive ? (
          <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center', paddingLeft: 25, paddingRight: 25, flexDirection: 'column' }}>
            <div style={{ width: '70%', margin: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <CheckOutlineIconCustom style={{ color: GREEN, width: 30, marginRight: 10 }} />
              <h4 style={{ color: GREEN, fontWeight: 'bold', fontSize: 20 }}><Entity entity="integrationCorrectlyConfigured" /></h4>
            </div>
            {integrationData ? (
              <FormFlatContainer
                title="integrationAdditionalInfo"
                titleStyle={{ marginLeft: 0 }}
                containerStyle={{ marginTop: 20, marginRight: 0 }}
              >
                <div style={{ marginBottom: 10 }}>
                  <h4 style={{ marginBottom: 0, fontWeight: 'bold' }}><Entity entity="opertoClientId" /></h4>
                  <h4 style={{ marginTop: 0 }}>{integrationData.clientId || '-'}</h4>
                </div>
                <div style={{ marginBottom: 10 }}>
                  <h4 style={{ marginBottom: 0, fontWeight: 'bold' }}><Entity entity="opertoClientSecret" /></h4>
                  <h4 style={{ marginTop: 0 }}>{integrationData.clientSecret || '-'}</h4>
                </div>
                <div style={{ marginBottom: 10 }}>
                  <h4 style={{ marginBottom: 0, fontWeight: 'bold' }}><Entity entity="buildingTimeZone" /></h4>
                  <h4 style={{ marginTop: 0 }}>{integrationData.timeZone || '-'}</h4>
                </div>
                <div style={{ marginBottom: 10 }}>
                  <h4 style={{ marginBottom: 0, fontWeight: 'bold' }}><Entity entity="opertoCheckInTimeOverride" /></h4>
                  <h4 style={{ marginTop: 0 }}>{formatSecondsFromStartOfDayToTimeDisplay(integrationData.checkInTimeOverride) || '-'}</h4>
                </div>
                <div style={{ marginBottom: 10 }}>
                  <h4 style={{ marginBottom: 0, fontWeight: 'bold' }}><Entity entity="opertoCheckOutTimeOverride" /></h4>
                  <h4 style={{ marginTop: 0 }}>{formatSecondsFromStartOfDayToTimeDisplay(integrationData.checkOutTimeOverride) || '-'}</h4>
                </div>
                <div style={{ marginBottom: 10 }}>
                  <h4 style={{ marginBottom: 0, fontWeight: 'bold' }}><Entity entity="opertoProperties" /></h4>
                  <h4 style={{ marginTop: 0 }}>{this.formatPropertiesList(integrationData.properties, opertoProperties)}</h4>
                </div>
                <div style={{ marginBottom: 10 }}>
                  <h4 style={{ marginBottom: 0, fontWeight: 'bold' }}><Entity entity="opertoCommonLockTagsTitle" /></h4>
                  <h4 style={{ marginTop: 0, marginBottom: 0 }}>{this.formatLockTagIds(integrationData.commonLockTagIds, lockTags)}</h4>
                </div>
              </FormFlatContainer>
            ) : null}
            <MDButton
              title={<Entity key={isActive} entity="disableIntegrationTitle" />}
              titleStyle={{ marginTop: 0, fontSize: 13 }}
              backgroundColor={RED}
              containerStyle={{ margin: 'auto', marginTop: 20  }}
              onClick={() => this.onDeactivateIntegrationRequest()}
            />
          </div>
        ) : (
          <div style={{ width: '70%', margin: 'auto' }}>
            <h4 style={{ margin: 0, marginTop: 20, marginBottom: 10, textAlign: 'center' }}>
              <Entity style={{ fontWeight: 'bold' }} entity="activateIntegrationTitle" data={{ integrationName: 'Operto' }} />
            </h4>
            <h4 style={{ margin: 0, textAlign: 'center', marginBottom: 20 }}>
              <Entity entity="activateOpertoIntegrationDescription" data={{ integrationName: 'operto' }} />
            </h4>
            {!properties ? (
              <div>
                <div style={{ marginTop: 20 }}>
                  <OpertoActivationForm
                    onSubmit={loginData => this.onOpertoLoginAndGetProperties(loginData)}
                  />
                </div>
                <MDButton
                  title={<Entity entity="activate" key={properties} />}
                  titleStyle={{ marginTop: 0, fontSize: 13 }}
                  backgroundColor={GREEN}
                  containerStyle={{ margin: 0, marginTop: 20  }}
                  onClick={() => dispatch(submit('OpertoActivationForm'))}
                />
              </div>
            ) : (
              <div>
                <div style={{ marginTop: 20 }}>
                  <OpertoSelectPropertiesForm
                    properties={properties}
                    availableLockTags={lockTags}
                    locksFilteredByTags={locksFilteredByTags}
                    onFetchMoreLocks={page => this.fetchLocksByTags(page, true)}
                    onLockInputChange={value => this.filterLockTags(value)}
                    onLockTagsChange={() => this.fetchLocksByTags()}
                    onLockFilterModeChange={() => this.fetchLocksByTags()}
                    onSubmit={formData => this.onActivateOpertoIntegration(formData)}
                  />
                </div>
                <MDButton
                  title={<Entity key={properties} entity="connectYourAccount" />}
                  titleStyle={{ marginTop: 0, fontSize: 13 }}
                  backgroundColor={GREEN}
                  containerStyle={{ margin: 0, marginTop: 20 }}
                  onClick={() => dispatch(submit('OpertoSelectPropertiesForm'))}
                />
                <IconButton onClick={() => this.onGoBackToLogin()}>
                  <ArrowLeftIconCustom style={{ color: '#3f3f3f', width: 20, marginRight: 5 }} />
                </IconButton>
                <Entity style={{ color: '#3f3f3f', marginTop: 2 }} entity="backToLogin" />
              </div>
            )}
          </div>
        )}
        {isActive !== null ? (
          <h5
            className="link-label"
            style={{ margin: 'auto', width: 'fit-content', marginTop: 20, fontSize: 16, textDecoration: 'underline' }}
            onClick={() => this.onOpenActivationInfo()}
          >
            <Entity entity="findOutMore" />
          </h5>
        ) : null}
      </div>
    );
  }
}

export default OpertoSettingsOperationalSection;
